<template>
    <!-- 填空题 -->
    <div>
        <div class="choose">
            <p class="title_t"
               v-if="!!checked">
                <span v-if="ask_length>1"
                      :class="{num:!myColor}">({{question.number}})</span>
                <span v-if="question.subject.content.length"
                      :class="[myColor?'inspect_myColor':'title_p']"
                      v-html="$options.filters.strReplace(question.subject.content,'\#\#','或')"></span>
                <img :src="question.subject.image"
                     v-if="question.subject.image" />
            </p>
            <p class="title_t"
               v-else>
                <span v-if="ask_length>1"
                      class="num">({{question.number}})</span>
                <span v-if="question.subject.content.length"
                      :class="{'title_p':ask_length>1}"
                      v-html="$options.filters.strReplace(question.subject.content,'\#\#','或')"></span>
                <img :src="question.subject.image"
                     v-if="question.subject.image" />
            </p>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
export default {
    props: ['question', 'askLength', "checked", 'number', 'myColor'],
    data () {
        return {

        }
    },
    components: {

    },
    computed: {
        ask_length () {
            return this.askLength ? this.askLength : 1
        },
    },
    beforeRouteLeave (to, from, next) {

    },
    methods: {

    },
    mounted () {

    },
    created () {
    },
    destroyed () {

    }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.title_t {
    background: #fff;
    // padding:24px/$ppr;
    line-height: 48px / $ppr;
    display: block;
    // border-bottom: #E8E8E8 1px/$ppr solid;
    // position:relative;
    .num {
        // position:absolute;
        // left:25px/$ppr;
        // top:25px/$ppr;
        // background:#aaa;
        display: inline-block;
    }
    .title_p {
        display: inline-block;
        // padding-left:50px/$ppr;
    }
}

.choose {
    background: #fff;
    margin-top: 24px / $ppr;
    .p {
        padding: 24px / $ppr;
        line-height: 48px / $ppr;
        border-bottom: #e8e8e8 1px / $ppr solid;
        min-height: 48px / $ppr;
    }
}
</style>
